import { AbstractControl, ValidationErrors } from '@angular/forms';

export class TreetopValidators {
  public static isUrl(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null;
    }

    const urlRegex = /^https?:\/\/(?:www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,}(:\d{1,5})?(\/[a-zA-Z0-9\-._~!$'()*+,;=:/?%#]*[^\s<>]*)?$/;

    const valid = urlRegex.test(control.value);

    return valid ? null : { url: true };
  }
}
